import PageHeader from '@/components/layout/PageHeader';
import QuoteForm from '@/components/marketing/QuoteForm';
import TrustBadges from '@/components/marketing/TrustBadges';
import { COMPANY } from '@/data/site';
import { Phone, Mail, MapPin, Clock, Languages } from 'lucide-react';

const contactRows = [
  { icon: Phone, label: 'Call · Main Line', value: COMPANY.phone, href: COMPANY.phoneHref },
  { icon: Phone, label: 'Call · Direct Line', value: COMPANY.phoneAlt, href: COMPANY.phoneAltHref, accent: true },
  { icon: Mail, label: 'Email', value: COMPANY.email, href: COMPANY.emailHref },
  { icon: MapPin, label: 'Service Area', value: COMPANY.serviceArea },
  { icon: Clock, label: 'Hours', value: 'Mon–Sat · 8am to 6pm' },
  { icon: Languages, label: 'Bilingual · Se Habla Español', value: 'English & Spanish speaking team', highlight: true },
];

export default function ContactPage() {
  return (
    <>
      <PageHeader
        chapter="Chapter 005"
        eyebrow="Contact"
        title={<>Tell us about<br />the project.</>}
        blurb="Fill out the form and a project manager will call you within one business day. Or reach us directly — we answer the phone."
      />

      <section className="relative bg-[#FAFAF5] py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5 space-y-4">
            {contactRows.map((r) => {
              const Inner = () => (
                <div className={`flex items-start gap-5 border p-6 transition-colors ${
                  r.highlight ? 'border-[#DC2626]/60 bg-[#DC2626]/[0.03]' : 'border-black/10 hover:border-[#1D4ED8]/60'
                }`}>
                  <div className={`w-11 h-11 grid place-items-center border shrink-0 ${
                    r.highlight ? 'border-[#DC2626] text-[#DC2626]' : 'border-black/15 text-[#1D4ED8]'
                  }`}>
                    <r.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className={`font-mono-label text-[10px] tracking-[0.24em] uppercase mb-1 ${
                      r.highlight ? 'text-[#DC2626]' : 'text-[#0A0A0A]/60'
                    }`}>{r.label}</div>
                    <div className="text-[#0A0A0A] text-lg md:text-xl break-all">{r.value}</div>
                  </div>
                </div>
              );
              return r.href ? (
                <a key={r.label} href={r.href} className="block">
                  <Inner />
                </a>
              ) : (
                <div key={r.label}><Inner /></div>
              );
            })}
          </div>
          <div className="md:col-span-7">
            <QuoteForm source="contact-page" />
          </div>
        </div>
      </section>

      <TrustBadges />
    </>
  );
}
